
import { z } from "zod";

export const PreferredLanguageValues = ["ENGLISH", "SPANISH"] as const;
export const PreferredLanguageSchema = z.enum(PreferredLanguageValues);
export const PreferredLanguage = PreferredLanguageSchema.enum;
export type PreferredLanguage = (typeof PreferredLanguageValues)[number];
export const PreferredLanguageDisplayNames = { "ENGLISH": "English",
"SPANISH": "Spanish", } satisfies Record<PreferredLanguage, string>;
